export default {
    setVuexDemo(state, options) {
        state.storeTest = options;
    },
    set_message(state,option){
        state.onMessageArrived = option;
    },
    set_devToday(state,option){
        state.todayDev = option;
    },
    //民品开阀实时状态
    set_valveOpen(state,option){
        state.valveOpen = option;
    },
    set_floorDeviceData(state,option){
        state.floorDeviceData = option;
    },
    //echart地图配置
    set_echart_config(state,option){
        state.Echartmap_config = option;
    },
    //高德地图配置
    set_config(state,option){
        state.map_config = option;
    },
    //民品地图配置
    set_map_other(state,option){
        state.map_other = option;
    },
    //头部配置
    setType(state,option){
        state.map_type = option;
    },
    //今日实时报警数
    set_todayAlarmNum(state,option){
        state.AlarmNum = option;
    },
    //今日实时在线数
    set_onlineNum(state,option){
        state.onlineNum = option;

    },
    //存储登录信息
    set_client(state,option){
        state.clients = option;
    },



    set_token(state, token) {
        state.token = token
        sessionStorage.token = token
    },
    del_token(state) {
        state.token = ''
        sessionStorage.removeItem('token')
    },
    //图表渲染使用
    setRedrawPage (state, option) {
        state.redrawPage = option;
    },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js